module.exports = __webpack_public_path__ + "static/media/app2.03954626.png";